export default "<div>\n  <canvas #canvas height=\"400px\" width=\"400px\"></canvas>\n</div>\n"